import { findFieldByElement } from './findFieldByElement';
import { findFieldByType } from './findFieldByType';

const findAddressField = fields => {
  const arr = Array.isArray(fields) ? fields : Object.values(fields);
  return arr.find(f => f.element === 'address');
};

const legacyExtractAddressParts = (fields, mode) => {
  const countryField = findFieldByElement(fields, 'country');
  const shippingCountryField = findFieldByType(fields, 'shipping-address-country');
  const billingCountryField = findFieldByType(fields, 'address-country');
  const country = countryField?.value || shippingCountryField?.value || billingCountryField?.value;

  const arr = Array.isArray(fields) ? fields : Object.values(fields);

  const postalCodeField = arr.find(
    field => field.type === 'address-postal_code' || field.type === 'shipping-address-postal_code',
  );
  const stateField = arr.find(
    field => field.type === 'address-state' || field.type === 'shipping-address-state',
  );

  return {
    country,
    state: stateField?.value,
    postalCode: postalCodeField?.value,
  };
};

export const extractAddressParts = (fields, mode = 'billing') => {
  const addressField = findAddressField(fields);

  const v = addressField?.value;
  if (v && (v.billing || v.shipping)) {
    const source = mode === 'shipping' ? (v.shipping ?? v.billing) : (v.billing ?? v.shipping);
    return {
      country: source?.country,
      state: source?.region,
      postalCode: source?.postalCode,
    };
  }

  return legacyExtractAddressParts(fields, mode);
};
